/**
 * Thin wrapper over the two `schema-compare-*-options-file` IPC channels.
 *
 * The `localStorage` test overrides mirror `settingsTransferApi.ts` — e2e
 * cannot click a native dialog, so in test mode the renderer supplies the
 * path and main skips the dialog. Both overrides are gated on
 * `electronAPI.testMode.isTestMode()`, so they are inert in a shipped build.
 */
import type {
  SchemaCompareOptionsFileExportResult,
  SchemaCompareOptionsFileImportResult,
} from '../types/schemaCompare';

const TEST_EXPORT_PATH_KEY = 'sql-studio-test-schema-compare-options-export-file';
const TEST_IMPORT_PATH_KEY = 'sql-studio-test-schema-compare-options-import-file';

function testOverridePath(key: string): string | undefined {
  if (!window.electronAPI?.testMode?.isTestMode?.()) return undefined;
  if (typeof localStorage === 'undefined') return undefined;
  return localStorage.getItem(key)?.trim() || undefined;
}

export async function exportCompareOptionsFileToDisk(args: {
  json: string;
  suggestedFileName: string;
}): Promise<SchemaCompareOptionsFileExportResult> {
  if (!window.electronAPI?.schemaCompare?.exportOptionsFile) {
    return { success: false, error: 'Exporting comparison options is unavailable here.' };
  }
  const filePath = testOverridePath(TEST_EXPORT_PATH_KEY);
  return window.electronAPI.schemaCompare.exportOptionsFile({
    json: args.json,
    suggestedFileName: args.suggestedFileName,
    ...(filePath ? { filePath } : {}),
  });
}

export async function importCompareOptionsFileFromDisk(): Promise<SchemaCompareOptionsFileImportResult> {
  if (!window.electronAPI?.schemaCompare?.importOptionsFile) {
    return { success: false, error: 'Loading comparison options is unavailable here.' };
  }
  const filePath = testOverridePath(TEST_IMPORT_PATH_KEY);
  return window.electronAPI.schemaCompare.importOptionsFile(filePath ? { filePath } : {});
}
